import React from 'react';
import styled from 'styled-components';
import createImageUrl from '../helpers/createImageUrl';

const BackgroundImageComponent = ({
  image,
  position,
  size,
  children,
  className,
}) => (
  <BackgroundImage
    className={className}
    position={position}
    size={size}
    xs={createImageUrl({ image, options: ['w_576', 'dpr_2.0', 'e_colorize:20', 'co_rgb:000000'] })}
    sm={createImageUrl({ image, options: ['w_728', 'dpr_2.0', 'e_colorize:20', 'co_rgb:000000'] })}
    md={createImageUrl({ image, options: ['w_990', 'dpr_2.0', 'e_colorize:20', 'co_rgb:000000'] })}
    lg={createImageUrl({ image, options: ['w_1200', 'dpr_2.0', 'e_colorize:20', 'co_rgb:000000'] })}
    xl={createImageUrl({ image, options: ['w_2400', 'dpr_2.0', 'e_colorize:20', 'co_rgb:000000'] })}
  >
    {children}
  </BackgroundImage>
);

const BackgroundImage = styled.div`
  background-image: url(${(props) => props.xs});
  background-size: ${(props) => props.size};
  background-position: ${(props) => props.position};
  background-repeat: no-repeat;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    background-image: url(${(props) => props.sm});
  }
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    background-image: url(${(props) => props.md});
  }
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    background-image: url(${(props) => props.lg});
  }
  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    background-image: url(${(props) => props.xl});
  }
`;

export default BackgroundImageComponent;
